import initInstance from './lib/kokuapp-shared-instance'

window.addEventListener('load', function () {
  initInstance()
})



// WEBPACK FOOTER //
// ./src/kokuapp_onload.js